var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 20,
    role: "img",
    "aria-label": "java",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "java") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 51,
    height: 20,
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 345,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 230
  }, "java"), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 230
  }, "java"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.ba8bff80572039b24896a28402fac3ea.svg";
export { ForwardRef as ReactComponent };